import { createAction, props } from '@ngrx/store';
import {
  PersonProfileSkeleton,
  PagedPersonProfileAudit,
  PagedBusinessPersonAudit,
  PagedAddressAudit,
  PagedPhoneNumberAudit,
  PagedEmailAddressAudit,
  PagedEmergencyContactAudit,
  PagedPersonAttributeAudit,
  PagedStaffInfoAudit,
  PagedPreferenceAudit,
  PagedExecutiveAssociateAudit,
  PagedCrewMemberTypeRatingAudit,
  PagedTaxInfoAudit,
  PagedPersonStaffGroupAudit,
  PagedPassengerAudit
} from '../../+models/person-profile-audit.model';
import { RefTypeItem } from '@sd-portal/shared/ref-type-item';

export const ResetPersonProfile = createAction('[SharedAudit PersonProfile] Reset');

// skeleton
export const LoadPersonProfileAuditSkeleton = createAction(
  '[SharedAudit PersonProfile] Load Person Profile Audit Skeleton'
);

export const PersonProfileAuditSkeletonLoaded = createAction(
  '[SharedAudit PersonProfile] Person Profile Audit Skeleton Loaded',
  props<{ payload: PersonProfileSkeleton }>()
);

export const PersonProfileAuditSkeletonLoadError = createAction(
  '[SharedAudit PersonProfile] Person Profile Audit Skeleton Load Error',
  props<{ err: any }>()
);

//Person Profile
export const LoadPersonProfileAudit = createAction(
  '[SharedAudit PersonProfile] Load Person Profile Audit',
  props<{ personId: number }>()
);

export const LoadNextPagePersonProfileAudit = createAction(
  '[SharedAudit PersonProfile] Load NextPage Person Profile Audit',
  props<{ personId: number }>()
);

export const PersonProfileAuditLoaded = createAction(
  '[SharedAudit PersonProfile] Person Profile Audit Loaded',
  props<{ personId: number; audits: PagedPersonProfileAudit }>()
);

export const PersonProfileAuditLoadError = createAction(
  '[SharedAudit PersonProfile] Person Profile Audit Load Error',
  props<{ err: any }>()
);

//Passenger
export const LoadPassengerAudit = createAction(
  '[SharedAudit Passenger] Load Person Profile Audit',
  props<{ passengerId: number }>()
);

export const LoadNextPagePassengerAudit = createAction(
  '[SharedAudit Passenger] Load NextPage Person Profile Audit',
  props<{ passengerId: number }>()
);

export const PassengerAuditLoaded = createAction(
  '[SharedAudit Passenger] Person Profile Audit Loaded',
  props<{ passengerId: number; audits: PagedPassengerAudit }>()
);

export const PassengerAuditLoadError = createAction(
  '[SharedAudit Passenger] Person Profile Audit Load Error',
  props<{ err: any }>()
);

// BusinessPerson
export const LoadBusinessPersonAudit = createAction(
  '[SharedAudit PersonProfile] Load BusinessPerson Audit',
  props<{ businessPersonId: number }>()
);

export const LoadNextPageBusinessPersonAudit = createAction(
  '[SharedAudit PersonProfile] Load NextPage BusinessPerson Audit',
  props<{ businessPersonId: number }>()
);

export const BusinessPersonAuditLoaded = createAction(
  '[SharedAudit PersonProfile] BusinessPerson Audit Loaded',
  props<{ businessPersonId: number; audits: PagedBusinessPersonAudit }>()
);

export const BusinessPersonAuditLoadError = createAction(
  '[SharedAudit PersonProfile] BusinessPerson Audit Load Error',
  props<{ err: any }>()
);

// PhoneNumber
export const LoadPhoneNumberAudit = createAction(
  '[SharedAudit PersonProfile] Load PhoneNumber Audit',
  props<{ phoneNumberId: number }>()
);

export const LoadNextPagePhoneNumberAudit = createAction(
  '[SharedAudit PersonProfile] Load NextPage PhoneNumber Audit',
  props<{ phoneNumberId: number }>()
);

export const PhoneNumberAuditLoaded = createAction(
  '[SharedAudit PersonProfile] PhoneNumber Audit Loaded',
  props<{ phoneNumberId: number; audits: PagedPhoneNumberAudit }>()
);

export const PhoneNumberAuditLoadError = createAction(
  '[SharedAudit PersonProfile] PhoneNumber Audit Load Error',
  props<{ err: any }>()
);

// EmailAddress
export const LoadEmailAddressAudit = createAction(
  '[SharedAudit PersonProfile] Load EmailAddress Audit',
  props<{ emailAddressId: number }>()
);

export const LoadNextPageEmailAddressAudit = createAction(
  '[SharedAudit PersonProfile] Load NextPage EmailAddress Audit',
  props<{ emailAddressId: number }>()
);

export const EmailAddressAuditLoaded = createAction(
  '[SharedAudit PersonProfile] EmailAddress Audit Loaded',
  props<{ emailAddressId: number; audits: PagedEmailAddressAudit }>()
);

export const EmailAddressAuditLoadError = createAction(
  '[SharedAudit PersonProfile] EmailAddress Audit Load Error',
  props<{ err: any }>()
);

// Address
export const LoadAddressAudit = createAction(
  '[SharedAudit PersonProfile] Load Address Audit',
  props<{ addressId: number }>()
);

export const LoadNextPageAddressAudit = createAction(
  '[SharedAudit PersonProfile] Load NextPage Address Audit',
  props<{ addressId: number }>()
);

export const AddressAuditLoaded = createAction(
  '[SharedAudit PersonProfile] Address Audit Loaded',
  props<{ addressId: number; audits: PagedAddressAudit }>()
);

export const AddressAuditLoadError = createAction(
  '[SharedAudit PersonProfile] Address Audit Load Error',
  props<{ err: any }>()
);

// EmergencyContact
export const LoadEmergencyContactAudit = createAction(
  '[SharedAudit PersonProfile] Load EmergencyContact Audit',
  props<{ emergencyContactId: number }>()
);

export const LoadNextPageEmergencyContactAudit = createAction(
  '[SharedAudit PersonProfile] Load NextPage EmergencyContact Audit',
  props<{ emergencyContactId: number }>()
);

export const EmergencyContactAuditLoaded = createAction(
  '[SharedAudit PersonProfile] EmergencyContact Audit Loaded',
  props<{ emergencyContactId: number; audits: PagedEmergencyContactAudit }>()
);

export const EmergencyContactAuditLoadError = createAction(
  '[SharedAudit PersonProfile] EmergencyContact Audit Load Error',
  props<{ err: any }>()
);

// EmergencyContactPhoneNumber
export const LoadEmergencyContactPhoneNumberAudit = createAction(
  '[SharedAudit PersonProfile] Load EmergencyContactPhoneNumber Audit',
  props<{ emergencyContactPhoneNumberId: number }>()
);

export const LoadNextPageEmergencyContactPhoneNumberAudit = createAction(
  '[SharedAudit PersonProfile] Load NextPage EmergencyContactPhoneNumber Audit',
  props<{ emergencyContactPhoneNumberId: number }>()
);

export const EmergencyContactPhoneNumberAuditLoaded = createAction(
  '[SharedAudit PersonProfile] EmergencyContactPhoneNumber Audit Loaded',
  props<{ emergencyContactPhoneNumberId: number; audits: PagedPhoneNumberAudit }>()
);

export const EmergencyContactPhoneNumberAuditLoadError = createAction(
  '[SharedAudit PersonProfile] EmergencyContactPhoneNumber Audit Load Error',
  props<{ err: any }>()
);

// PersonAttribute
export const LoadPersonAttributeAudit = createAction(
  '[SharedAudit PersonProfile] Load PersonAttribute Audit',
  props<{ personAttributeId: number }>()
);

export const LoadNextPagePersonAttributeAudit = createAction(
  '[SharedAudit PersonProfile] Load NextPage PersonAttribute Audit',
  props<{ personAttributeId: number }>()
);

export const PersonAttributeAuditLoaded = createAction(
  '[SharedAudit PersonProfile] PersonAttribute Audit Loaded',
  props<{ personAttributeId: number; audits: PagedPersonAttributeAudit }>()
);

export const PersonAttributeAuditLoadError = createAction(
  '[SharedAudit PersonProfile] PersonAttribute Audit Load Error',
  props<{ err: any }>()
);

// Staff Group
export const LoadPersonStaffGroupAudit = createAction(
  '[SharedAudit PersonProfile] Load PersonStaffGroup Audit',
  props<{ personStaffGroupId: number }>()
);

export const LoadNextPagePersonStaffGroupAudit = createAction(
  '[SharedAudit PersonProfile] Load NextPage PersonStaffGroup Audit',
  props<{ personStaffGroupId: number }>()
);

export const PersonStaffGroupAuditLoaded = createAction(
  '[SharedAudit PersonProfile] PersonStaffGroup Audit Loaded',
  props<{ personStaffGroupId: number; audits: PagedPersonStaffGroupAudit }>()
);

export const PersonStaffGroupAuditLoadError = createAction(
  '[SharedAudit PersonProfile] PersonStaffGroup Audit Load Error',
  props<{ err: any }>()
);

// Staff Info
export const LoadStaffInfoAudit = createAction(
  '[SharedAudit PersonProfile] Load StaffInfo Audit',
  props<{ staffInfoId: number }>()
);

export const LoadNextPageStaffInfoAudit = createAction(
  '[SharedAudit PersonProfile] Load NextPage StaffInfo Audit',
  props<{ staffInfoId: number }>()
);

export const StaffInfoAuditLoaded = createAction(
  '[SharedAudit PersonProfile] StaffInfo Audit Loaded',
  props<{ staffInfoId: number; audits: PagedStaffInfoAudit }>()
);

export const StaffInfoAuditLoadError = createAction(
  '[SharedAudit PersonProfile] StaffInfo Audit Load Error',
  props<{ err: any }>()
);

// Preferences
export const ResetPreferenceCatering = createAction(
  '[SharedAudit PersonProfile PreferencesCatering] Reset'
);

export const LoadPreferenceCateringAudit = createAction(
  '[SharedAudit PersonProfile] Load Preference Catering Audit',
  props<{ preferenceId: number }>()
);

export const LoadNextPagePreferenceCateringAudit = createAction(
  '[SharedAudit PersonProfile] Load NextPage Preference Catering Audit',
  props<{ preferenceId: number }>()
);

export const PreferenceCateringAuditLoaded = createAction(
  '[SharedAudit PersonProfile] Preference Catering Audit Loaded',
  props<{ preferenceId: number; audits: PagedPreferenceAudit }>()
);

export const PreferenceCateringAuditLoadError = createAction(
  '[SharedAudit PersonProfile] Preference Catering Audit Load Error',
  props<{ err: any }>()
);

export const LoadPreferenceGroundTransportationAudit = createAction(
  '[SharedAudit PersonProfile] Load Preference Ground Transportation Audit',
  props<{ preferenceId: number }>()
);

export const LoadNextPagePreferenceGroundTransportationAudit = createAction(
  '[SharedAudit PersonProfile] Load NextPage Preference Ground Transportation Audit',
  props<{ preferenceId: number }>()
);

export const PreferenceGroundTransportationAuditLoaded = createAction(
  '[SharedAudit PersonProfile] Preference Ground Transportation Audit Loaded',
  props<{ preferenceId: number; audits: PagedPreferenceAudit }>()
);

export const PreferenceGroundTransportationAuditLoadError = createAction(
  '[SharedAudit PersonProfile] Preference Ground Transportation Audit Load Error',
  props<{ err: any }>()
);

export const LoadPreferenceHotelAudit = createAction(
  '[SharedAudit PersonProfile] Load Preference Hotel Audit',
  props<{ preferenceId: number }>()
);

export const LoadNextPagePreferenceHotelAudit = createAction(
  '[SharedAudit PersonProfile] Load NextPage Preference Hotel Audit',
  props<{ preferenceId: number }>()
);

export const PreferenceHotelAuditLoaded = createAction(
  '[SharedAudit PersonProfile] Preference Hotel Audit Loaded',
  props<{ preferenceId: number; audits: PagedPreferenceAudit }>()
);

export const PreferenceHotelAuditLoadError = createAction(
  '[SharedAudit PersonProfile] Preference Hotel Audit Load Error',
  props<{ err: any }>()
);

// ExecutiveAssociate
export const LoadExecutiveAssociateAudit = createAction(
  '[SharedAudit PersonProfile] Load ExecutiveAssociate Audit',
  props<{ executiveAssociateId: number }>()
);

export const LoadNextPageExecutiveAssociateAudit = createAction(
  '[SharedAudit PersonProfile] Load NextPage ExecutiveAssociate Audit',
  props<{ executiveAssociateId: number }>()
);

export const ExecutiveAssociateAuditLoaded = createAction(
  '[SharedAudit PersonProfile] ExecutiveAssociate Audit Loaded',
  props<{ executiveAssociateId: number; audits: PagedExecutiveAssociateAudit }>()
);

export const ExecutiveAssociateAuditLoadError = createAction(
  '[SharedAudit PersonProfile] ExecutiveAssociate Audit Load Error',
  props<{ err: any }>()
);

// ExecutiveAssociatePhoneNumber

export const LoadExecutiveAssociatePhoneNumberAudit = createAction(
  '[SharedAudit PersonProfile] Load ExecutiveAssociatePhoneNumber Audit',
  props<{ executiveAssociatePhoneNumberId: number }>()
);

export const LoadNextPageExecutiveAssociatePhoneNumberAudit = createAction(
  '[SharedAudit PersonProfile] Load NextPage ExecutiveAssociatePhoneNumber Audit',
  props<{ executiveAssociatePhoneNumberId: number }>()
);

export const ExecutiveAssociatePhoneNumberAuditLoaded = createAction(
  '[SharedAudit PersonProfile] ExecutiveAssociatePhoneNumber Audit Loaded',
  props<{ executiveAssociatePhoneNumberId: number; audits: PagedPhoneNumberAudit }>()
);

export const ExecutiveAssociatePhoneNumberAuditLoadError = createAction(
  '[SharedAudit PersonProfile] ExecutiveAssociatePhoneNumber Audit Load Error',
  props<{ err: any }>()
);

// ExecutiveAssociateEmailAddress
export const LoadExecutiveAssociateEmailAudit = createAction(
  '[SharedAudit PersonProfile] Load ExecutiveAssociateEmail Audit',
  props<{ executiveAssociateEmailId: number }>()
);

export const LoadNextPageExecutiveAssociateEmailAudit = createAction(
  '[SharedAudit PersonProfile] Load NextPage ExecutiveAssociateEmail Audit',
  props<{ executiveAssociateEmailId: number }>()
);

export const ExecutiveAssociateEmailAuditLoaded = createAction(
  '[SharedAudit PersonProfile] ExecutiveAssociateEmail Audit Loaded',
  props<{ executiveAssociateEmailId: number; audits: PagedEmailAddressAudit }>()
);

export const ExecutiveAssociateEmailAuditLoadError = createAction(
  '[SharedAudit PersonProfile] ExecutiveAssociateEmail Audit Load Error',
  props<{ err: any }>()
);

// CrewMemberTypeRating

export const LoadCrewMemberTypeRatingAudit = createAction(
  '[SharedAudit PersonProfile] Load CrewMemberTypeRating Audit',
  props<{ crewMemberTypeRatingId: number }>()
);

export const LoadNextPageCrewMemberTypeRatingAudit = createAction(
  '[SharedAudit PersonProfile] Load NextPage CrewMemberTypeRating Audit',
  props<{ crewMemberTypeRatingId: number }>()
);

export const CrewMemberTypeRatingAuditLoaded = createAction(
  '[SharedAudit PersonProfile] CrewMemberTypeRating Audit Loaded',
  props<{ crewMemberTypeRatingId: number; audits: PagedCrewMemberTypeRatingAudit }>()
);

export const CrewMemberTypeRatingAuditLoadError = createAction(
  '[SharedAudit PersonProfile] CrewMemberTypeRating Audit Load Error',
  props<{ err: any }>()
);

export const LoadCrewMemberTypeRatingTypes = createAction(
  '[SharedAudit PersonProfile] Load CrewMemberTypeRating Types'
);

export const CrewMemberTypeRatingTypesLoaded = createAction(
  '[SharedAudit PersonProfile] CrewMemberTypeRating Types Loaded',
  props<{ payload: RefTypeItem[] }>()
);

export const CrewMemberTypeRatingTypesLoadError = createAction(
  '[SharedAudit PersonProfile] CrewMemberTypeRating Types Load Error',
  props<{ err: any }>()
);

// TaxInfo
export const LoadTaxInfoAudit = createAction(
  '[SharedAudit PersonProfile] Load TaxInfo Audit',
  props<{ taxInfoId: number }>()
);

export const LoadNextPageTaxInfoAudit = createAction(
  '[SharedAudit PersonProfile Load NextPage TaxInfo Audit',
  props<{ taxInfoId: number }>()
);

export const TaxInfoAuditLoaded = createAction(
  '[SharedAudit PersonProfile] TaxInfo Audit Loaded',
  props<{ taxInfoId: number; audits: PagedTaxInfoAudit }>()
);

export const TaxInfoAuditLoadError = createAction(
  '[SharedAudit PersonProfile] TaxInfo Audit Load Error',
  props<{ err: any }>()
);
